export default __webpack_public_path__ + "static/media/carousel_1.f96a0f3c.jpg";